import tabs from './tabs';

// ==============================|| MENU ITEMS ||============================== //

const menuItems = {
  items: [tabs]
};

export default menuItems;
